import React from 'react';
import styles from './A_StatusTag.module.css';
import cn from 'classnames';

type StatusType = 'sent' | 'rejected' | 'accepted';

interface A_StatusTagProps {
  status: StatusType;
  className?: string;
}

const statusConfig: Record<StatusType, { text: string }> = {
  sent: {
    text: 'Отправлено',
  },
  rejected: {
    text: 'Отклонено',
  },
  accepted: {
    text: 'Принято',
  },
};

export default function A_StatusTag({ status, className }: A_StatusTagProps) {
  const config = statusConfig[status];

  return (
    <div className={cn(styles.wrapper, styles[status], className)}>
      <span className={cn('text-caption', styles.text)}>{config.text}</span>
    </div>
  );
}
